import React from 'react';
import { UnAuthorizedFooter } from './UnAuthorizedFooter';
import { AuthorizedFooter } from './AuthorizedFooter';
import { useUserPageContextState } from '../user';
import { useStyleContextState } from '../styleContext';

export const Footer = (props) => {
	const { isAuthenticated, customerName } = useUserPageContextState();
	const { languages } = useStyleContextState();
	const { footerNavigation } = useStyleContextState();
	const generalProps = {
		...props,
		languages,
		isAuthenticated,
		customerName,
		footerNavigation,
	};
	const FooterComponent = isAuthenticated ? AuthorizedFooter : UnAuthorizedFooter;

	return <FooterComponent {...generalProps} />;
};
